import styled from "@emotion/styled";
import { type CSSProperties, type HTMLAttributes, type ReactNode } from "react";

import { classNames, PanelDragItem, Tooltip } from "@skilitics/designer-ui-components";
import { useDraggable } from "@skilitics/drag-drop";

import { DND_CREATABLE_ID, type DND_TEMPLATE_ID } from "./dndConstants";
import type { DraggableData } from "./dndSchemas";

// Not sure where this will end up as it should ultimately be more dynamic but this is better code re-use for now.

export type Props = {
  type: typeof DND_TEMPLATE_ID | typeof DND_CREATABLE_ID;
  templateId?: number;
  definitionId?: string;
  typeId: string;
  displayName: string;
  disabled?: boolean;
  tooltip?: ReactNode;
} & HTMLAttributes<HTMLDivElement> &
  (
    | {
        type: typeof DND_CREATABLE_ID;
      }
    | {
        type: typeof DND_TEMPLATE_ID;
        templateId: number;
      }
  );

export const NautilusNodeDraggableItem = ({
  type,
  typeId,
  displayName,
  disabled,
  tooltip,
  definitionId,
  templateId,
  children,
  ...domAttrs
}: Props) => {
  const identifier = type === DND_CREATABLE_ID ? definitionId || typeId : templateId;
  const node =
    type === DND_CREATABLE_ID
      ? {
          type,
          typeId,
          definitionId,
        }
      : {
          type,
          typeId,
          templateId,
        };
  const { ref, isDragging } = useDraggable({
    id: `${identifier}:${type}`,
    data: {
      title: displayName,
      node,
      useCustomDragOverlay: true,
    } satisfies DraggableData,
    disabled,
  });

  const style: CSSProperties = {
    opacity: isDragging || disabled ? 0.5 : 1,
  };

  return (
    <>
      <Tooltip title={tooltip} placement="top">
        <span>
          <SidebarDragItem
            ref={ref}
            className={classNames({
              [`${domAttrs.className}`]: !!domAttrs.className,
            })}
            {...domAttrs}
            style={{ ...domAttrs.style, ...style }}
          >
            {children}
          </SidebarDragItem>
        </span>
      </Tooltip>
    </>
  );
};

const SidebarDragItem = styled(PanelDragItem)`
  margin-bottom: 5px;
  user-select: none;
  font-size: ${({ theme }) => theme.fontSizeSmall};

  cursor: grab;

  svg {
    font-size: 14px;
    vertical-align: top;
  }
`;
